<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-menu-fold`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M43 36a1 1 0 011 1v2a1 1 0 01-1 1H5a1 1 0 01-1-1v-2a1 1 0 011-1h38zM13.81 17.575a1.19 1.19 0 011.184 1.068l.006.121v10.234a1.19 1.19 0 01-1.69 1.08l-.114-.061L4.708 24.9a1.19 1.19 0 01-.107-1.965l.107-.073 8.488-5.117a1.19 1.19 0 01.615-.17zM43 22a1 1 0 011 1v2a1 1 0 01-1 1H23a1 1 0 01-1-1v-2a1 1 0 011-1h20zm0-14a1 1 0 011 1v2a1 1 0 01-1 1H5a1 1 0 01-1-1V9a1 1 0 011-1h38z"/></svg>
</template>
<script>

export default {
  name: 'IconMenuFold',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
